export const PageConfig = {
    AdministratorOnly: { isAdminOnly: true, userReadOnly: false },
    UserReadOnly: { isAdminOnly: false, userReadOnly: true },
};